import {useRef, useState, useCallback, useEffect} from 'react'
import DetailPage from './DetailPage'
import {VideoContext} from '../../contexts/VideoContext'



const DetailPageWithVideoContext = (props) => {
  // Refs to the actual <video> element and controls:
  const videoRef     = useRef(null)
  const controlsRef  = useRef(null)
  const expandRef    = useRef(null)
  const aspectRef    = useRef(null)
  const containerRef = useRef(null)


  // Playback state:
  const [isMuted, setIsMuted]           = useState(true)
  const [isPlaying, setIsPlaying]       = useState(false)
  const [isExpanded, setIsExpanded]     = useState(false)
  const [isVideoActive, setVideoActive] = useState(false)

  // play / pause methods:
  const play = useCallback((e) => {
    e?.stopPropagation()
    const v = videoRef.current
    if (!v) return
    v.style.transform = 'scale(1)'
    setVideoActive(true)  
    v.play().then(() => setIsPlaying(true)).catch(()=>{})
  }, [])

  const pause = useCallback((e) => {
    e?.stopPropagation()
    const v = videoRef.current
    if (!v) return
    v.pause()
    setIsPlaying(false)
  }, [])

  // toggle mute:
  const toggleMute = useCallback((e) => {
    console.log('toggleMute')
    e.stopPropagation()
    const v = videoRef.current
    if (!v) return
    v.muted = !v.muted
    setIsMuted(v.muted)
  }, [])

  // toggle expand (same as your old code):
  const toggleExpand = useCallback((e) => {
    e?.stopPropagation()
    if (!containerRef.current || !aspectRef.current || !expandRef.current) return
    const w = containerRef.current.offsetWidth

    if (!isExpanded) {
      // expand
      aspectRef.current.style.paddingTop = '177.7%'
      containerRef.current.style.height = `${(w * 3) / 2}px`
      expandRef.current.style.transform = 'rotate(180deg)'
    } else {
      // collapse
      aspectRef.current.style.paddingTop = '100%'
      containerRef.current.style.height = `${w}px`
      expandRef.current.style.transform = 'rotate(0deg)'
    }

    setIsExpanded(value => !value)
  }, [isExpanded])


  // hide / reset video:
  const hideVideo = useCallback((e) => {
    e?.stopPropagation()
    const v = videoRef.current
    if (!v) return
    v.style.transform = 'scale(0)'

    if (isExpanded) {
      const w = containerRef.current.offsetWidth
      aspectRef.current.style.paddingTop = '100%'
      containerRef.current.style.height = `${w}px`
      expandRef.current.style.transform = 'rotate(0deg)'
    }

    setTimeout(() => {
      v.pause()
      v.currentTime = 0
      setIsPlaying(false)
      setVideoActive(false)
    }, 300)
  }, [isExpanded])


  // Attach native events once videoRef is set:
  useEffect(() => {
    const v = videoRef.current
    if (!v) return
    const onVolume = () => setIsMuted(v.muted || v.volume < 0.1)
    const onPlay   = () => {
      if (controlsRef.current) {
        controlsRef.current.style.opacity = '1'
        controlsRef.current.style.display = 'flex'
      }
    }
    v.addEventListener('play', onPlay)
    v.addEventListener('volumechange', onVolume)
    v.addEventListener('ended', hideVideo, { once: true })

    return () => {
      v.removeEventListener('play', onPlay)
      v.removeEventListener('volumechange', onVolume)
      v.removeEventListener('ended', hideVideo)
    }
  }, [hideVideo])

  // Assemble the context value
  const contextValue = {
    videoRef,
    controlsRef,
    expandRef,
    aspectRef,
    containerRef,
    isPlaying,
    isVideoActive,
    isMuted,
    play,
    pause,
    toggleMute,
    toggleExpand,
    hideVideo
  }

  return (
    <VideoContext.Provider value={contextValue}>
      {/* Now render your entire DetailPage; inside it,
          DetailPageImageContainer will pull videoRef etc.
          and GradientPlayButton (wherever it sits) can call play()/pause() */}
      <DetailPage {...props} />
    </VideoContext.Provider>
  )
}


export default DetailPageWithVideoContext

